import Constant from '@/const';
import axios from 'axios';

const putDiagnose = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/diagnose/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putDiagnose;
